import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DelegationLibraryComponent } from './delegation-library/delegation-library.component';
import { SharedModule } from '../shared/shared.module';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldsetModule } from 'primeng/fieldset';
import { DocumentSearchModule } from '../document-search/document-search.module';
import { DialogModule } from 'primeng/dialog';
import { MyDelegationsComponent } from './delegation-library/delegation-library-menu/my-delegations/my-delegations.component';
import { DelegatedToMeComponent } from './delegation-library/delegation-library-menu/delegated-to-me/delegated-to-me.component';
import { DelegationPanelListComponent } from './delegation-library/delegation-library-menu/delegation-panel-list/delegation-panel-list.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DelegateSliderModule } from '../delegate-slider/delegate-slider.module';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { LabelComponent } from '../shared-components/label/label.component';


@NgModule({
  declarations: [
    DelegationLibraryComponent,
    MyDelegationsComponent,
    DelegatedToMeComponent,
    DelegationPanelListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TabViewModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    BptProgressSpinnerModule,    
    MessageModule,
    MessagesModule,    
    BptDateTimeModule,
    BptDropdownModule,
    ReactiveFormsModule,
    FieldsetModule,
    DocumentSearchModule,
    DialogModule,
    CheckboxModule,
    FormsModule,
    DelegateSliderModule,
    SpinnerComponent,
    EmptyResultsComponent,
    LabelComponent
  ],
  providers: [ConfirmationService],

})
export class DelegateModule { }
